import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import Example from './example'
import AddExample from './addexample'
import { connect } from 'react-redux'
import { changeRule, deleteRule, saveRule, selectRule, deselectRule } from '../../actioncreators/actioncreators'
import swal from 'sweetalert'
import truncate from 'truncate'
const { Component } = React

const preventPropagation = (e) => {
  e.stopPropagation()
}

export class Rule extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      hover: false
    }

    this.ruleInput = React.createRef()
    this.examplesRef = React.createRef()
    this.examplesCollapseIndicatorRef = React.createRef()
  }

  componentDidMount () {
    if (this.props.allowAutofocus) {
      this.ruleInput.current.focus()
    }
  }

  render () {
    let examples = this.props.rule.examples.map((example) => {
      return (<Example example={example} key={example.id} />)
    })
    return (
      <Draggable
        draggableId={'rule-draggable-' + this.props.rule.id.toString()}
        index={this.props.index}
        type='rule'>
        {provided => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            onDoubleClick={preventPropagation}
          >
            <div
              style={{
                minWidth: 290,
                maxWidth: 290,
                display: 'flex',
                flexDirection: 'column',
                marginRight: 5
              }}
            >
              <div className='text-center' style={{ display: this.props.splittingMode ? 'block' : 'none', marginBottom: 5 }}>
                <button className='btn btn-default btn-sm' style={{ display: this.props.rule.selected ? 'none' : 'inline' }} onClick={this.props.selectRule} title='Select this rule and example'>
                  Unselected
                </button>
                <button className='btn btn-success btn-sm' style={{ display: this.props.rule.selected ? 'inline' : 'none' }} onClick={this.props.deselectRule} title='Select this rule and example'>
                  Selected
                </button>
              </div>
              <div
                {...provided.dragHandleProps}
                style={{
                  height: 14,
                  marginLeft: 3,
                  marginRight: 3,
                  color: 'white',
                  backgroundColor: '#0C8CE6',
                  fontSize: 10
                }}
                onMouseDown={(e) => {
                  this.examplesRef.current.style.display = 'none'
                  this.examplesCollapseIndicatorRef.current.style.display = 'block'
                  provided.dragHandleProps.onMouseDown(e)
                }
                }
                onMouseUp={() => {
                  this.examplesRef.current.style.display = 'block'
                  this.examplesCollapseIndicatorRef.current.style.display = 'none'
                }
                }
              >
                <span
                  style={{
                    marginLeft: 5
                  }}
                ><i className='fas fa-grip-horizontal' /> Rule</span>
              </div>
              <div className='panel panel-default' style={{ marginLeft: 3, marginRight: 3, border: 'none' }}>
                <div className='panel-body' style={{ padding: '7px 4px', backgroundColor: '#ABAAAA' }}
                  onMouseEnter={() => this.setState({ hover: true })}
                  onMouseLeave={() => this.setState({ hover: false })}>
                  <button className={this.state.hover ? 'btn btn-default btn-xs' : 'hidden btn btn-default btn-xs'}
                    style={{ position: 'absolute', marginTop: -15, marginLeft: 254, zIndex: '100' }}
                    onClick={this.props.deleteRule}
                    title='Delete rule'>
                    <span className='glyphicon glyphicon-trash' aria-hidden='true' />
                  </button>
                  <textarea
                    className='form-control'
                    rows='4'
                    value={this.props.rule.text}
                    onChange={this.props.onChange}
                    onBlur={this.props.saveRule}
                    placeholder='Enter a rule which captures a behaviour of your story'
                    style={{ resize: 'vertical' }}
                    ref={this.ruleInput}
                  />
                  <div className='exampleCollapseIndicator' ref={this.examplesCollapseIndicatorRef} style={{ textAlign: 'center', fontSize: 11, margin: '4px 0px', display: 'none' }}>examples collapsed</div>
                </div>
                <ul className='list-group collapsibleExamples' ref={this.examplesRef}>
                  {examples}
                </ul>
                <div className='panel-footer' style={{ padding: '0px 4px 4px 4px', backgroundColor: '#ABAAAA', border: 'none' }}>
                  <div className='text-center'>
                    <AddExample rule={this.props.rule.id} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    rule: ownProps.rule,
    index: ownProps.index,
    allowAutofocus: store.exampleMap.allowAutofocus,
    splittingMode: store.exampleMap.splittingMode
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    onChange: function (event) {
      dispatch(changeRule(ownProps.rule.id, event.target.value))
    },
    deleteRule: function () {
      swal({
        title: 'Delete this rule?',
        text: `Click OK to delete "${truncate(ownProps.rule.text, 30)}"`,
        icon: 'warning',
        buttons: true
      })
        .then((willDelete) => {
          if (willDelete) {
            dispatch(deleteRule(ownProps.rule.id))
          }
        })
    },
    saveRule: function () {
      dispatch(saveRule())
    },
    selectRule: function () {
      dispatch(selectRule(ownProps.rule.id))
    },
    deselectRule: function () {
      dispatch(deselectRule(ownProps.rule.id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rule)
